import React, { ReactNode } from 'react';

import ABLincoln, { User, Namespace } from './ABLincoln';

interface Props {
  user: User | null;
  tests?: { [namespaceName: string]: Namespace } | null;
  children: ReactNode;
}

// Context to use ablincoln with all loaded tests.
export const ABLincolnContext = React.createContext<ABLincoln | undefined>(undefined);

export function ABLincolnContextProvider({ user, tests, children }: Props) {
  let ablincoln: ABLincoln | undefined;
  if (user && tests) {
    ablincoln = new ABLincoln(user, tests);
  }

  return <ABLincolnContext.Provider value={ablincoln}>{children}</ABLincolnContext.Provider>;
}
